import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useCurrentUser } from 'src/hooks';
import { showOtherModalsAtom } from 'src/store';

type Props = {
  setIsOpen: (isOpen: boolean) => void;
};

const DISABLED = true;

export const useShowHolidayModal = ({ setIsOpen }: Props) => {
  const { user } = useCurrentUser();
  const [showOtherModals] = useAtom(showOtherModalsAtom);

  return useEffect(() => {
    // DISABLED FOR NOW
    if (DISABLED) {
      return;
    }

    // early return, logic is pending or the WelcomeModal is currently being shown.
    if (!showOtherModals) {
      return;
    }

    // if the user is subscribed - don't show the modal
    if (user?.subscription.tier !== 'free') {
      return;
    }

    const holidayModalLocalStorage: null | string =
      localStorage.getItem('holidayModalSeen');

    const holidayModalVals: {
      lastSeen: string;
      numberOfTimesSeen: number;
    } | null = holidayModalLocalStorage
      ? JSON.parse(holidayModalLocalStorage)
      : null;

    // if the user has never seen the modal, show it and set the timestamp and number of times seen
    if (holidayModalVals === null) {
      localStorage.setItem(
        'holidayModalSeen',
        JSON.stringify({
          lastSeen: new Date().toISOString(),
          numberOfTimesSeen: 1,
        }),
      );
      setIsOpen(true);
    } else {
      try {
        const lastSeen = new Date(holidayModalVals.lastSeen);
        const now = new Date();
        const diffTime = Math.abs(now.getTime() - lastSeen.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays >= 7 && holidayModalVals.numberOfTimesSeen < 3) {
          localStorage.setItem(
            'holidayModalSeen',
            JSON.stringify({
              lastSeen: new Date().toISOString(),
              numberOfTimesSeen: holidayModalVals.numberOfTimesSeen + 1,
            }),
          );
          setIsOpen(true);
        }
      } catch (err) {
        // if there's an error, update the timestamp but don't show the modal again.
        localStorage.setItem(
          'holidayModalSeen',
          JSON.stringify({
            lastSeen: new Date().toISOString(),
            numberOfTimesSeen: holidayModalVals.numberOfTimesSeen + 1,
          }),
        );
      }
    }
  }, [setIsOpen, user, showOtherModals]);
};
